@if (showStatus) {
  <div class="translation-status">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="status-item loading">
        <i class="bi bi-arrow-clockwise spin" aria-hidden="true"></i>
        <span>Loading translations...</span>
      </div>
    }
    <!-- Error State -->
    @if (hasError && !isLoading) {
      <div class="status-item error" role="alert">
        <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
        <span>{{ errorMessage }}</span>
        <button
          type="button"
          class="recovery-btn"
          (click)="attemptRecovery()"
          aria-label="Attempt to recover from translation error"
          >
          <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
          Retry
        </button>
      </div>
    }
    <!-- Success State -->
    @if (showSuccess) {
      <div class="status-item success" role="status">
        <i class="bi bi-check-circle" aria-hidden="true"></i>
        <span>{{ successMessage }}</span>
      </div>
    }
    <!-- Debug Info (only in development) -->
    @if (showDebugInfo) {
      <div class="debug-info">
        <h4>Translation Debug Info</h4>
        <p><strong>Current Language:</strong> {{ currentLanguage }}</p>
        <p><strong>Is Loading:</strong> {{ isLoading }}</p>
        <p><strong>Has Error:</strong> {{ hasError }}</p>
        <p><strong>Critical Errors:</strong> {{ hasCriticalErrors }}</p>
        @if (errorStats) {
          <div class="error-stats">
            <h5>Error Statistics:</h5>
            <ul>
              <li>Missing Keys: {{ errorStats.missing_key }}</li>
              <li>Loading Failed: {{ errorStats.loading_failed }}</li>
              <li>Network Errors: {{ errorStats.network_error }}</li>
              <li>Parse Errors: {{ errorStats.parse_error }}</li>
              <li>Unknown Errors: {{ errorStats.unknown }}</li>
            </ul>
          </div>
        }
      </div>
    }
  </div>
}
